import { Instagram, SocialNetworksAvailables, TikTok, Twitter, Youtube } from '@hub/shared'
import './social-username.component.scoped.scss'

interface Props {
  socialNetworkObject: Instagram | Twitter | Youtube | TikTok
  socialNetwork: SocialNetworksAvailables
}

export default ({ socialNetworkObject, socialNetwork }: Props) => {
  return (
    <h5 title={socialNetworkObject?.username}>
      {socialNetwork !== 'youtube' ? '@' : null}
      {socialNetworkObject?.username}
    </h5>
  )
}
